export const featuresActionTypes = {
    'SET_USER_FEATURES': 'SET_USER_FEATURES',
}